import React, {Component} from "react"
import {navigate, StaticQuery} from "gatsby"
import {trackCustomEvent} from "gatsby-plugin-google-analytics"
import Img from "gatsby-image"
import feedbackStyles from "./feedback2.module.css"
import Firebase from "./Firebase/firebase"
import {v4 as uuidv4} from "uuid"

const HAPPY = "happy";
const MEH = "meh";
const SAD = "sad";

const WHY_BAD_OPTIONS = [
    "Too long",
    "Confusing",
    "Didn't help me understand",
    "Boring",
    "Too difficult"
];

class Feedback extends Component {
    constructor(props) {
      super(props);

      var sections = [];
      for (var i = 0; i < this.props.tocData.sections.length; i++) {
          sections.push(this.props.tocData.sections[i].title);
      }

      this.state = {
        uuid: uuidv4(),
        lesson: this.props.name,
        sections: sections,

        feedbackChoice: "",
        selectedWhyBadOptions: [],
        selectedSections: [],
        freeTextInput: "",
        showQuestionOne: false,
        showQuestionTwo: false,
        showFreeTextInput: false,
        submitted: false,
        collapsed: false,
      }

      this.feedbackRef = React.createRef();
      this.handleClickOutsideFunction = (e) => this.handleClickOutside(e);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutsideFunction);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideFunction);
    }

    handleClickOutside(e) {
        if (this.state.feedbackChoice !== "" && this.feedbackRef && this.feedbackRef.current !== undefined && !this.feedbackRef.current.contains(e.target)) {
            this.setState({collapsed: true});
        }
    }

    submitFeedback() {
        (new Firebase()).sendLessonFeedback2(
            this.state.uuid,
            this.state.lesson,
            this.state.feedbackChoice,
            this.state.selectedWhyBadOptions,
            this.state.selectedSections,
            this.state.freeTextInput);
    }

    toggleWhyBadOption(option) {
        if (this.state.selectedWhyBadOptions.includes(option)) {
            this.setState({
                selectedWhyBadOptions: this.state.selectedWhyBadOptions.filter((x) => x !== option)
            })
        } else {
            var selectedWhyBadOptionsCopy = [...this.state.selectedWhyBadOptions];
            selectedWhyBadOptionsCopy.push(option);
            this.setState({
                selectedWhyBadOptions: selectedWhyBadOptionsCopy
            })
        }
    }

    toggleSection(section) {
        if (this.state.selectedSections.includes(section)) {
            this.setState({
                selectedSections: this.state.selectedSections.filter((x) => x !== section)
            })
        } else {
            var selectedSectionsCopy = [...this.state.selectedSections];
            selectedSectionsCopy.push(section);
            this.setState({
                selectedSections: selectedSectionsCopy
            })
        }
    }

    getWhyBadButtons() {
        let buttons = [];
        for (var i = 0; i < WHY_BAD_OPTIONS.length; i++) {
            let option = WHY_BAD_OPTIONS[i];
            let selected = this.state.selectedWhyBadOptions.includes(option);
            buttons.push(
                <button
                    key={i}
                    className={feedbackStyles.chip + (selected ? (" " + feedbackStyles.selected) : "")}
                    disabled={this.state.showQuestionTwo}
                    onClick={() => this.toggleWhyBadOption(option)}>
                    {option}
                </button>
            );
        }
        return buttons;
    }

    getSectionButtons() {
        let buttons = [];
        for (var i = 0; i < this.state.sections.length; i++) {
            let section = this.state.sections[i];
            let selected = this.state.selectedSections.includes(section);
            buttons.push(
                <button
                    key={i}
                    className={feedbackStyles.chip + (selected ? (" " + feedbackStyles.selected) : "")}
                    disabled={this.state.showFreeTextInput}
                    onClick={() => this.toggleSection(section)}>
                    {section}
                </button>
            );
        }
        return buttons;
    }

    handleFreeTextInput(e) {
        this.setState({freeTextInput: e.target.value})
    }

    render() {
        const displayStyle = {
            maxHeight: (this.state.sections.length) * 70 + 'px',
            opacity: 1,
            transition: 'max-height 1s',
        };

        const hiddenStyle = {
            maxHeight: 0,
            opacity: 0,
            overflow: 'hidden',
        }

        const displayStyleCollapseView = {
            maxHeight: '100vh',
            opacity: 1,
            transition: 'max-height 1s',
        }

        const hiddenStyleCollapseView = {
            maxHeight: 0,
            overflow: 'hidden',
            transition: 'max-height 0.5s',
        }

        return (
          <div className={feedbackStyles.feedback} ref={this.feedbackRef}>
            { this.state.submitted
                ?
                    <>
                        <div>
                            <div className={feedbackStyles.question} style={{textAlign:"center"}}>
                                Thank you for your feedback!
                            </div>
                            <div style={{textAlign:"center", fontSize:"1.5rem", marginTop:"0.5rem"}}>
                                🤗
                            </div>
                        </div>
                    </>
                :
                    <div>
                        <div className={feedbackStyles.question}>
                            Was this lesson helpful?
                        </div>
                        <div style={{display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gridGap:"5px", marginTop:".5rem"}}>
                            <button
                                className={feedbackStyles.chip + (this.state.feedbackChoice === HAPPY ? (" " + feedbackStyles.selected) : "")}
                                style={{fontSize:"25px"}}
                                disabled={this.state.feedbackChoice !== ""}
                                onClick={() => this.setState({feedbackChoice: HAPPY, showQuestionTwo: true}, () => this.submitFeedback())}>
                                😍
                            </button>
                            <button
                                className={feedbackStyles.chip + (this.state.feedbackChoice === MEH ? (" " + feedbackStyles.selected) : "")}
                                style={{fontSize:"25px"}}
                                disabled={this.state.feedbackChoice !== ""}
                                onClick={() => this.setState({feedbackChoice: MEH, showQuestionOne: true}, () => this.submitFeedback())}>
                                😐
                            </button>
                            <button
                                className={feedbackStyles.chip + (this.state.feedbackChoice === SAD ? (" " + feedbackStyles.selected) : "")}
                                style={{fontSize:"25px"}}
                                disabled={this.state.feedbackChoice !== ""}
                                onClick={() => this.setState({feedbackChoice: SAD, showQuestionOne: true}, () => this.submitFeedback())}>
                                😒
                            </button>
                        </div>

                        <div style={this.state.collapsed ? hiddenStyleCollapseView : displayStyleCollapseView}>
                            <div style={this.state.showQuestionOne ? displayStyle : hiddenStyle}>
                                <div className={feedbackStyles.question} style={{marginTop:"1rem"}}>
                                    { this.state.feedbackChoice === MEH ? "How come?" : "Why wasn't it helpful?" }
                                </div>
                                <div style={{textAlign:"center", display: "flex", flexWrap: "wrap", marginTop: '0.5rem'}}>
                                    {this.getWhyBadButtons()}
                                </div>
                                <div style={((this.state.selectedWhyBadOptions.length === 0) || this.state.showQuestionTwo) ? hiddenStyle : displayStyle}>
                                    <div style={{width:"100%", marginTop:"0.5rem"}}>
                                        <div style={{width:"100%", margin:"0 auto"}}>
                                            <button className={feedbackStyles.submit} onClick={() => this.setState({showQuestionTwo: true}, () => this.submitFeedback())}>Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={this.state.showQuestionTwo ? displayStyle : hiddenStyle}>
                                <div className={feedbackStyles.question} style={{marginTop:"1rem"}}>
                                    Which sections were {this.state.feedbackChoice !== HAPPY ? "not" : ""} helpful?
                                </div>
                                <div style={{textAlign:"center", display: "flex", flexWrap: "wrap", marginTop: '0.5rem'}}>
                                    {this.getSectionButtons()}
                                </div>
                                <div style={((this.state.selectedSections.length === 0) || this.state.showFreeTextInput) ? hiddenStyle : displayStyle}>
                                    <div style={{width:"100%", marginTop:"0.5rem"}}>
                                        <div style={{width:"100%", margin:"0 auto"}}>
                                            <button className={feedbackStyles.submit} onClick={() => this.setState({showFreeTextInput: true}, () => this.submitFeedback())}>Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={this.state.showFreeTextInput ? displayStyle : hiddenStyle}>
                                <div className={feedbackStyles.question} style={{marginTop:"1rem"}}>
                                    { this.state.feedbackChoice === HAPPY ? "How were they helpful?" : "Anything else?" }
                                </div>
                                <div style={{marginTop:"0.5rem"}}>
                                    <textarea
                                        style={{width:"100%", resize:"none", fontSize:"14px", lineHeight:"20px", height:"3rem", padding:"5px", fontFamily: "Inter", color:"var(--color-Black-Jeans-80p)", backgroundColor:"var(--color-Snow-Day", borderRadius:"5px"}}
                                        value={this.state.freeTextInput}
                                        onChange={(e) => this.handleFreeTextInput(e)}
                                    />
                                </div>

                                <div style={{width:"100%", marginTop:"0.5rem"}}>
                                    <div style={{width:"100%", margin:"0 auto"}}>
                                        <button className={feedbackStyles.submit} onClick={() => this.setState({submitted: true}, () => this.submitFeedback())}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={this.state.collapsed && this.state.feedbackChoice !== "" ? displayStyle : hiddenStyle}>
                            <div style={{width:"100%", marginTop:"0.5rem"}}>
                                <div style={{width:"100%", margin:"0 auto"}}>
                                    <button className={feedbackStyles.submit} onClick={() => this.setState({collapsed: false})}>Continue Feedback</button>
                                </div>
                            </div>
                        </div>
                    </div>
            }
          </div>
        )
    }
}

export default Feedback;
